module.exports = __webpack_public_path__ + "static/media/1.2ed69ca3.JPG";